var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommittingGoalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11983_168981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9C8 9.26522 7.89464 9.51957 7.70711 9.70711C7.51957 9.89464 7.26522 10 7 10C6.73478 10 6.48043 9.89464 6.29289 9.70711C6.10536 9.51957 6 9.26522 6 9C6 8.73478 6.10536 8.48043 6.29289 8.29289C6.48043 8.10536 6.73478 8 7 8C7.26522 8 7.51957 8.10536 7.70711 8.29289C7.89464 8.48043 8 8.73478 8 9ZM11 9C11 10.0609 10.5786 11.0783 9.82843 11.8284C9.07828 12.5786 8.06087 13 7 13C5.93913 13 4.92172 12.5786 4.17157 11.8284C3.42143 11.0783 3 10.0609 3 9C3 7.93913 3.42143 6.92172 4.17157 6.17157C4.92172 5.42143 5.93913 5 7 5C8.06087 5 9.07828 5.42143 9.82843 6.17157C10.5786 6.92172 11 7.93913 11 9ZM10 9C10 8.20435 9.68393 7.44129 9.12132 6.87868C8.55871 6.31607 7.79565 6 7 6C6.20435 6 5.44129 6.31607 4.87868 6.87868C4.31607 7.44129 4 8.20435 4 9C4 9.79565 4.31607 10.5587 4.87868 11.1213C5.44129 11.6839 6.20435 12 7 12C7.79565 12 8.55871 11.6839 9.12132 11.1213C9.68393 10.5587 10 9.79565 10 9ZM14 9C14 10.8565 13.2625 12.637 11.9497 13.9497C10.637 15.2625 8.85652 16 7 16C5.14348 16 3.36301 15.2625 2.05025 13.9497C0.737498 12.637 0 10.8565 0 9C0 7.14348 0.737498 5.36301 2.05025 4.05025C3.36301 2.7375 5.14348 2 7 2C8.85652 2 10.637 2.7375 11.9497 4.05025C13.2625 5.36301 14 7.14348 14 9ZM13 9C13 8.21207 12.8448 7.43185 12.5433 6.7039C12.2417 5.97595 11.7998 5.31451 11.2426 4.75736C10.6855 4.20021 10.0241 3.75825 9.2961 3.45672C8.56815 3.15519 7.78793 3 7 3C6.21207 3 5.43185 3.15519 4.7039 3.45672C3.97595 3.75825 3.31451 4.20021 2.75736 4.75736C2.20021 5.31451 1.75825 5.97595 1.45672 6.7039C1.15519 7.43185 1 8.21207 1 9C1 10.5913 1.63214 12.1174 2.75736 13.2426C3.88258 14.3679 5.4087 15 7 15C8.5913 15 10.1174 14.3679 11.2426 13.2426C12.3679 12.1174 13 10.5913 13 9Z",
    fill: "#D1E2F0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11983_168981)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.06641,
    y: 2.13281,
    width: 5.33333,
    height: 4.26667,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C8 2.93913 8.42143 1.92172 9.17157 1.17157C9.92172 0.421427 10.9391 0 12 0C13.0609 0 14.0783 0.421427 14.8284 1.17157C15.5786 1.92172 16 2.93913 16 4C16 5.06087 15.5786 6.07828 14.8284 6.82843C14.0783 7.57857 13.0609 8 12 8C10.9391 8 9.92172 7.57857 9.17157 6.82843C8.42143 6.07828 8 5.06087 8 4ZM11.7717 5.712L14.0747 2.83307L13.6587 2.50027L11.6949 4.95413L10.304 3.7952L9.96267 4.2048L11.7717 5.712Z",
    fill: "#16A34A"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11983_168981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11983_168981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommittingGoalIcon);
export default __webpack_public_path__ + "static/media/CommittingGoalIcon.b0b57620cbef1c6d375d625712a25958.svg";
export { ForwardRef as ReactComponent };